import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import { ClaimCycleCheckingSampleLinkContainerModel} from '../../../../../../models';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ClaimCycleSampleLinkService extends BaseApiTemplateService<ClaimCycleCheckingSampleLinkContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'cycle-checking-sample-links/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-checking-sample-links/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-checking-sample-links/backoffice-ep';
    this.httpClient = http;
  }

  approve(request: any[], visa: ApiVisa): Observable<BasicApiResponseModel<ClaimCycleCheckingSampleLinkContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-checking-sample-links/finance-acceptance/backoffice-ep';

    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'cycle-checking-sample-links/finance-acceptance/backoffice-ep';
    }

    return this.httpClient.put<BasicApiResponseModel<ClaimCycleCheckingSampleLinkContainerModel>>(url, request, this.getHttpHeader(visa));
  }

  onHold(request: any, visa: ApiVisa): Observable<BasicApiResponseModel<ClaimCycleCheckingSampleLinkContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-checking-sample-links/processors/on-hold/backoffice-ep';

    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'cycle-checking-sample-links/processors/on-hold/backoffice-ep';
    }

    return this.httpClient.put<BasicApiResponseModel<ClaimCycleCheckingSampleLinkContainerModel>>(url, request, this.getHttpHeader(visa));
  }

}


